var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Bxjsgl_edit),
      expression: "Bxjsgl_edit"
    }]
  }, [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "float": "left",
      "margin": "-40px 0 0 40px",
      "font-weight": "600"
    }
  }, [_vm._v("保险基数管理-详情")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "height": "40px",
      "margin-top": "-40px",
      "margin-right": "40px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    on: {
      "click": _vm.Return
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "750px",
      "background-color": "white",
      "margin": "75px 40px 0 40px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "2% 3% 0 3%"
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "header-cell-style": {
        background: '#F0F0F0',
        color: '#000000'
      },
      "row-class-name": _vm.tableRowClassName,
      "data": _vm.tableData,
      "tooltip-effect": "dark",
      "height": "540",
      "span-method": _vm.arraySpanMethod
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "",
      "align": "center",
      "label": "城市"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "minimum_wage",
      "align": "center",
      "label": "最低工资"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "minimum_wage",
      "align": "center",
      "label": "五险"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "minimum_wage",
      "align": "center",
      "label": "缴费基数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "minimum_wage",
      "align": "center",
      "label": "缴纳方式"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "minimum_wage",
      "align": "center",
      "label": "个人比例"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "minimum_wage",
      "align": "center",
      "label": "公司缴费比例"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "minimum_wage",
      "align": "center",
      "label": "物业账户"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "minimum_wage",
      "align": "center",
      "label": "环境账户"
    }
  })], 1)], 1)], 1)])], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59f7944d","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jcrsgl/Bxjsgl/Bxjsgl_edit.vue
// module id = null
// module chunks = 